//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import HelloWorld from './components/HelloWorld.vue'

// AOS.init();

export default {
  name: 'LayoutDefault',

  components: {
    // HelloWorld
  },

  data () {
    return {
      leftDrawerOpen: false,
      nama : '',
      email : '',
      // list_menu : [],
    }
  },
  methods: {
    
    cekToken(){
      fetch(this.$store.state.url.URL_APP + "checkAuth", {
          method: "GET",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              // console.log(res_data.message)
              if (res_data.message == 'Tidak ter-Authorisasi') {

                localStorage.removeItem("token");
                localStorage.removeItem("profile");
                localStorage.removeItem("listmenu");
                this.$router.push("/login");
              } 
      });
    },

  },

  computed: {
    checkLogin() {
      if (this.$route.name === 'login' || this.$route.name === 'register') {
          return true;
      } else {
          return false;
      }
    },
  },

  mounted () {
    // var get_profile = JSON.parse(localStorage.profile);
    // this.$store.state.lcProfile = get_profile.profile;

    // this.nama = this.$store.state.lcProfile.nama;
    // this.email = this.$store.state.lcProfile.email;

    // console.log(get_profile);
    
    this.cekToken()


    // this.list_menu = JSON.parse(localStorage.menu);


// provinsi
    // var inistorage = JSON.parse(localStorage.profile)
    // console.log(this.$store.state.lcProfile.provinsi);
    // console.log(this.$store.state.lcProfile.kabupaten);
    // console.log(this.$store.state.lcProfile.kecamatan);
  },
}
